<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">THE CUCKOO’S CHILD</h1>
<div class="auth"><span class="center">Marjorie Eccles</span></div>
<div class="logo"><img alt="Image Missing" height="51" src="OEBPS/images/logo.jpg" width="72"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?58f65547